import './index.scss';

const Hero = () => (
  <section className="hero">
    <div className="hero-eyebrow">
      <span className="dot-green" />
       Open to 2027 New-Grad roles | Canada & US
    </div>

    <h1 className="hero-name">
      Jahan<br />Shah<span>.</span>
    </h1>

    <p className="hero-tagline">
      Computer Engineering student @<strong>UBC</strong>, graduating June 2027. <br />
      I build full-stack, AI, and systems projects that turn messy real-world workflows into useful software.
    </p>

    <div className="hero-actions">
      <a href="#work" className="btn-primary">Explore my work ↓</a>
      <a
        href="https://drive.google.com/file/d/1PvA4tU7OHMRA2FvJRFNqlhSTZa-eQ9OG/view?usp=sharing"
        target="_blank"
        rel="noreferrer"
        className="btn-secondary"
      >
        Resume ↗
      </a>
    </div>

    <div className="impact-strip">
      <div className="impact-item">
        <div className="impact-num amber">10,000+</div>
        <div className="impact-label">Students served</div>
        <div className="impact-sub">Live UBCO parking availability</div>
      </div>
      <div className="impact-item">
        <div className="impact-num white">10%</div>
        <div className="impact-label">Faster Compliance lookups</div>
        <div className="impact-sub">Payment-validation tool</div>
      </div>
      <div className="impact-item">
        <div className="impact-num green">30+</div>
        <div className="impact-label">Users in Week 1</div>
        <div className="impact-sub">via LinkedIn for LaLiga Insights</div>
      </div>
      <div className="impact-item">
        <div className="impact-num blue">&gt;96%</div>
        <div className="impact-label">Validation accuracy</div>
        <div className="impact-sub">Potato disease classifier</div>
      </div>
    </div>
  </section>
);

export default Hero;
